import React, { useState, useEffect } from 'react';
import {
  Box,
  CircularProgress,
  Grid,
  Card,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { getInsuranceDetails } from '../../../v2/Benefits/Beneficiary/APIs/action';
import { toast } from 'react-toastify';
import BenefitCard from '../../../v2/Benefits/Beneficiary/Components/BenefitCard';
import FirmDetails from '../../../v2/Benefits/Beneficiary/Components/FirmDetails';
import { CustomButton } from '../../../v2/MUI_custom_component';
import ExistingBeneficiaryModal from './Components/ExistingBeneficiaryModal';
import AddNpsBeneficiary from './Components/AddNpsBeneficiary';
import { useBackroute } from '../../../contexts/BackrouteContext';
import ExitModal from '../../Common/ExitModal';
import VerifyPhoneModal from './Components/VerifyPhoneModal';
import ResidentCheckModal from './Components/ResidentCheckModal';

const AddGapBeneficiary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width: 1200px)');
  const { updateBackroute, resetBackroute } = useBackroute();
   const { selectedEntity: company_esi_id } = useSelector(
      (state) => state.entityReducer,
    );

  const [insuranceType, setInsuranceType] = useState(
    location?.state?.insurance_type,
  );
  
  const [selectedCompanyEntity, setSelectedCompanyEntity] = useState(
    location?.state?.selectedCompanyEntity || company_esi_id,
  );

  const [loader, setLoader] = useState(false);
  const [insuranceData, setInsuracedata] = useState(null);
  const [showExistingModal, setShowExistingModal] = useState(false);
  const [returnTransactionId, setReturnTransactionId] = useState(null);
  const [savedFormData, setSavedFormData] = useState(null);
  const [hasFormActivity, setHasFormActivity] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showResidentModal, setShowResidentModal] = useState(false);
  const [restartKey, setRestartKey] = useState(0);

  useEffect(() => {
    updateBackroute({ customHandler: () => setShowExitModal(true) });
    return () => resetBackroute();
  }, []);

  const fetchInsuranceDetails = async (type, entity) => {
    setLoader(true);
    const { data, error, message } = await getInsuranceDetails(type, entity);
    setLoader(false);
    if (!error) {
      setInsuracedata(data);
    } else {
      toast.error(message);
    }
  };

  const handleVerifyCancel = () => {
    setShowVerifyModal(false);
    navigate('/beneficiary');
  };

  const handleVerified = () => {
    setShowVerifyModal(false);
  };

  const handleResidentYes = () => {
    setShowResidentModal(false);
    setShowVerifyModal(true);
  };

  const handleResidentNo = () => {
    setShowResidentModal(false);
    navigate('/beneficiary');
  };

  const handleRestart = () => {
    setReturnTransactionId(null);
    setSavedFormData(null);
    setRestartKey((k) => k + 1);
    setShowVerifyModal(true);
  };

  const handleBeforeDigiLockerRedirect = (sessionId, formData) => {
    sessionStorage.setItem(
      'digilocker_pending',
      JSON.stringify({
        insuranceType,
        selectedCompanyEntity,
        session_id: sessionId,
        formData,
      }),
    );
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const transactionId = params.get('transaction_id');

    if (transactionId) {
      const saved = JSON.parse(
        sessionStorage.getItem('digilocker_pending') || '{}',
      );
      sessionStorage.removeItem('digilocker_pending');
      window.history.replaceState({}, '', location.pathname);
      setReturnTransactionId(transactionId);
      if (saved.formData) {
        setSavedFormData(saved.formData);
      }
      if (saved.insuranceType) setInsuranceType(saved.insuranceType);
      if (saved.selectedCompanyEntity)
        setSelectedCompanyEntity(saved.selectedCompanyEntity);
      if (saved.insuranceType && saved.selectedCompanyEntity) {
        fetchInsuranceDetails(saved.insuranceType, saved.selectedCompanyEntity);
      }
    } else if (insuranceType && selectedCompanyEntity) {
      setShowResidentModal(true);
      fetchInsuranceDetails(insuranceType, selectedCompanyEntity);
    }
  }, []);

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 1, md: 2 },
      }}
    >
      {!loader ? (
        <Grid
          container
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Grid
            item
            xs={12}
            sm={6}
          >
            <BenefitCard
              item={insuranceData?.benefit_card}
              sx={{ height: '100%' }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
          >
            <Card
              sx={{
                boxShadow: 'none',
                p: 2,
                borderRadius: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
              }}
            >
              {insuranceData?.selected_firm &&
                insuranceData?.selected_firm.map((detail, i) => (
                  <React.Fragment key={i}>
                    <FirmDetails detail={detail} />
                  </React.Fragment>
                ))}
            </Card>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                alignItems: 'flex-start',
                width: '100%',
              }}
            >
              {!hasFormActivity &&
                !!insuranceData?.existing_beneficiaries?.length && (
                  <>
                    <Typography variant='h2'>
                      Add Beneficiary for NPS
                    </Typography>

                    <CustomButton
                      variant='filled'
                      sx={{ width: '100%' }}
                      color={'primary'}
                      onClick={() => setShowExistingModal(true)}
                      label={'Choose Existing'}
                    />
                    <Typography
                      variant='p1'
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      or
                    </Typography>
                  </>
                )}
              <AddNpsBeneficiary
                key={restartKey}
                insuranceData={insuranceData}
                owner_type_text={insuranceData?.owner_type_text}
                owner_list={insuranceData?.owner_list}
                confirmation_text_for_digilocker={
                  insuranceData?.confirmation_text_for_digilocker
                }
                returnTransactionId={returnTransactionId}
                onBeforeDigiLockerRedirect={handleBeforeDigiLockerRedirect}
                savedFormData={savedFormData}
                onFormActivity={() => setHasFormActivity(true)}
                onRestart={handleRestart}
                hasFormActivity={hasFormActivity}
              />
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 3,
          }}
        >
          <CircularProgress
            size={24}
            sx={{ color: '#995A00' }}
          />
        </Box>
      )}
      <ResidentCheckModal
        open={showResidentModal}
        onYes={handleResidentYes}
        onNo={handleResidentNo}
      />
      <VerifyPhoneModal
        open={showVerifyModal}
        onCancel={handleVerifyCancel}
        onVerified={handleVerified}
      />
      <ExistingBeneficiaryModal
        open={showExistingModal}
        onClose={() => setShowExistingModal(false)}
        data={insuranceData?.existing_beneficiaries}
        insuranceData={insuranceData}
        returnTransactionId={returnTransactionId}
      />
      <ExitModal
        open={showExitModal}
        onClose={() => setShowExitModal(false)}
        onConfirm={() => navigate('/beneficiary')}
        title='Are you sure you want to exit?'
        subtitle='This action cannot be undone. All data would be lost?'
        confirmLabel='Yes'
        cancelLabel='No'
      />
    </Box>
  );
};

export default AddGapBeneficiary;
